/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedProductCarouselItem_edge = {
    readonly cmsData: {
        readonly title: string | null;
        readonly description: string | null;
    } | null;
    readonly node: {
        readonly localizedPdpUrl: string | null;
        readonly creators: ReadonlyArray<{
            readonly attribution: string | null;
            readonly creator: {
                readonly displayName: string | null;
            } | null;
        } | null> | null;
        readonly " $fragmentRefs": FragmentRefs<"LazyImageWrapper_item" | "ItemImage_item">;
    } | null;
    readonly " $refType": "SharedProductCarouselItem_edge";
};
export type SharedProductCarouselItem_edge$data = SharedProductCarouselItem_edge;
export type SharedProductCarouselItem_edge$key = {
    readonly " $data"?: SharedProductCarouselItem_edge$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedProductCarouselItem_edge">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedProductCarouselItem_edge",
  "type": "CmsItemsEdge",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cmsData",
      "storageKey": null,
      "args": null,
      "concreteType": "CmsData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "Item",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "localizedPdpUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "creators",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemCreator",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "attribution",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "creator",
              "storageKey": null,
              "args": null,
              "concreteType": "Creator",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayName",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "LazyImageWrapper_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "ItemImage_item",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '6eb700a795b6c3d7b1476992363d64f0';
export default node;
